
<div class="row" *ngIf="isProjectRejected">
  <div class="col">
    <div class="alert alert-danger"><span>This project has been rejected for the following reason: {{ rejectedReason }}</span><span *ngIf="allowUnRejectProject">
        <button class="btn btn-sm float-right btn-outline-dark" type="button" style="margin-top: -0.25em;" (click)="removeProjectRejection()">Remove Project Rejection</button></span></div>
  </div>
</div>